export default __webpack_public_path__ + "static/air-care-c3a6bbdc8b837ae2d3065f6a41f2d4df.svg";